import { RouteRecordRaw, RouteLocationNormalizedLoadedGeneric } from 'vue-router';

export const mineRouters: RouteRecordRaw[] = [
  // {
  //   path: '/withdrawal',
  //   name: 'Withdrawal',
  //   component: () => import('@/pages/h5/Withdrawal/Withdrawal.vue'),
  //   meta: { title: '提现' },
  // },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/pages/h5/Mine/Mine.vue'),
    meta: { title: '我的', disabledNavBar: true },
  },
  {
    path: '/accountDetail',
    name: 'AccountDetail',
    redirect: '/my-wallet',
    // component: () => import('@/pages/h5/Withdrawal/AccountDetail.vue'),
    meta: { title: '提现' },
  },
  {
    path: '/myBankcard',
    name: 'MyBankcard',
    component: () => import('@/pages/h5/Bankcard/MyBankcard.vue'),
    meta: { title: '我的账户' },
  },
  {
    path: '/bindBankcardOld',
    name: 'BindBankcardOld',
    component: () => import('@/pages/h5/Bankcard/BindBankcard.vue'),
    meta: { title: '绑定银行卡' },
  },
  {
    path: '/bindBankcard',
    name: 'BindBankcard',
    component: () => import('@/pages/h5/Bankcard/BindBankcard/BindBankcard.vue'),
    meta: { title: '我的银行卡' },
  },
  {
    path: '/testBindCard',
    name: 'TestBindCard',
    component: () => import('@/pages/testBindCard.vue'),
    meta: { title: '我的银行卡' },
  },
  {
    path: '/selectOrder',
    name: 'selectOrder',
    component: () => import('@/pages/h5/Withdrawal/selectOrder.vue'),
    meta: { title: '选择提现订单' },
  },
  {
    path: '/concatUs',
    name: 'concatUs',
    component: () => import('@/pages/h5/Mine/ContactUs.vue'),
    meta: { title: '联系我们' },
  },
  {
    path: '/agreementList',
    name: 'agreementList',
    component: () => import('@/pages/h5/Mine/Agreement.vue'),
    meta: { title: '协议与政策' },
  },
  {
    path: '/setConfig',
    name: 'setConfig',
    component: () => import('@/pages/h5/Mine/SetConfig.vue'),
    meta: { title: '设置' },
  },
  {
    path: '/myTeam',
    name: 'MyTeam',
    component: () => import('@/pages/h5/Mine/MyTeam.vue'),
    meta: { title: '我的团队' },
  },
  {
    path: '/my-wallet',
    name: 'MyWallet',
    component: () => import('@/pages/h5/Mine/MyWallet/MyWallet.vue'),
    meta: { title: '账户详情', disabledNavBar: true },
  },
  {
    path: '/toWithdrawal',
    name: 'ToWithdrawal',
    component: () => import('@/pages/h5/Withdrawal/ToWithdrawal/ToWithdrawal.vue'),
    meta: { title: '提现', disabledNavBar: true },
  },
  {
    path: '/addAlipay',
    name: 'AddAlipayAccount',
    component: () => import('@/pages/h5/Withdrawal/AddAlipayAccount/index.vue'),
    meta: { title: '绑定支付宝' },
  },
  {
    path: '/withdrawRecord',
    name: 'WithdrawRecord',
    component: () => import('@/pages/h5/Withdrawal/WithdrawRecord/Index.vue'),
    meta: { title: '提现记录', disabledNavBar: true },
  },
  {
    path: '/withdrawalDetails',
    name: 'WithdrawalDetails',
    component: () => import('@/pages/h5/Withdrawal/WithdrawalDetails/index.vue'),
    meta: { title: '提现详情', disabledNavBar: true },
  },
  {
    path: '/setUserInfo',
    name: 'SetUserInfo',
    component: () => import('@/pages/h5/Mine/SetUserInfo.vue'),
    meta: { title: '编辑资料', disabledNavBar: true },
  },
  {
    path: '/setUserPhone',
    name: 'SetUserPhone',
    component: () => import('@/pages/h5/Mine/SetPhone.vue'),
    meta: { title: '更换手机号', disabledNavBar: true },
  },
  //Forgot password
  {
    path: '/forgotPassword/:type',
    name: 'ForgotPassword',
    component: () => import('@/pages/h5/Mine/ForgotPassword.vue'),
    meta: { title: '忘记密码' },
  },
];
